import getHorizontalContentAlignment from './horizontal-content-alignment';
import getVerticalContentAlignment from './vertical-content-alignment';
import getBorderRadiuses from './border-radiuses';
import getPaddings from './paddings';
import getGaps from './gaps';

export default {
  getHorizontalContentAlignment,
  getVerticalContentAlignment,
  getBorderRadiuses,
  getPaddings,
  getGaps,
};
